import React from "react";
import PropTypes from "prop-types";
import Link from "../../Link";
import { transformLink } from "../../../helpers/";
import ReactHtmlParser from "react-html-parser";
import { makeStyles } from "@material-ui/styles";
import { graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import styles from "./styles";

const useStyles = makeStyles((theme) => styles(theme));

export const CoreImageBlock = (props) => {
  const classes = useStyles();
  if (!props.attributes.url) return null;
  let image = null;

  const dimensions = getDimensions(props.attributes.url);

  image = (
    <div
      className="gatsby-image-wrapper"
      style={{
        display: "flex",
      }}
    >
      {/* <div style={{ paddingBottom: "100%" }} /> */}
      <img
        src={props.attributes.url}
        alt={props.attributes.alt ? props.attributes.alt : ""}
        className={`img-align-${props.attributes.align} ${classes.root} ${
          props.attributes.className ? props.attributes.className : ""
        }`}
        width={props.attributes.width < 1 ? dimensions?.width : ""}
        height={props.attributes.height < 1 ? dimensions?.height : ""}
        style={{
          position: "relative",
          // top: 0,
          // left: 0,
          width: "100%",
          // height: "100%",
          objectFit: "cover",
          objectPosition: "center center",
        }}
      />
    </div>
  );

  // Use the gatsby image if available
  if (
    props.attributes.localFile !== null &&
    props.attributes.localFile !== "undefined"
  ) {
    if (props.attributes.localFile?.childImageSharp) {
      image = (
        <GatsbyImage
          image={props.attributes.localFile.childImageSharp.gatsbyImageData}
          alt={props.attributes.alt ? props.attributes.alt : ""}
          className={`img-align-${props.attributes.align} ${classes.root} ${
            props.attributes.className ? props.attributes.className : ""
          }`}
          width={props.attributes.width ? props.attributes.width : ""}
          height={props.attributes.height ? props.attributes.height : ""}
        />
      );
    } else if (props.attributes.localFile?.publicURL) {
      // Gifs do not have a childImageSharp
      image = (
        <img
          src={props.attributes.localFile.publicURL}
          alt={props.attributes.alt ? props.attributes.alt : ""}
          className={`img-align-${props.attributes.align} ${classes.root} ${
            props.attributes.className ? props.attributes.className : ""
          }`}
          width={props.attributes.width ? props.attributes.width : ""}
          height={props.attributes.height ? props.attributes.height : ""}
        />
      );
    }
  }

  if (props.attributes.caption) {
    image = (
      <span className="image-with-caption">
        {image}
        <p
          variant="body1"
          className={`caption ${classes.imageCaption} ${classes.imageCaptionTheme}`}
          paragraph={true}
        >
          {ReactHtmlParser(props.attributes.caption, {
            transform: transformLink,
          })}
        </p>
      </span>
    );
  }

  if (props.attributes.href) {
    return (
      <Link
        to={props.attributes.href}
        title={props.attributes.title ? props.attributes.title : ""}
        className={props.attributes.linkClass ? props.attributes.linkClass : ""}
      >
        {image}
      </Link>
    );
  } else {
    return image;
  }
};

CoreImageBlock.propTypes = {
  attributes: PropTypes.object.isRequired,
};

export const CoreImageBlockFragment = graphql`
  fragment CoreImageBlock on WpBlock {
    ... on WpCoreImageBlock {
      name
      attributes {
        __typename
        ... on WpCoreImageBlockAttributes {
          align
          alt
          caption
          className
          height
          href
          id
          linkClass
          linkDestination
          linkTarget
          rel
          sizeSlug
          title
          url
          width
          localFile {
            id
            publicURL
            childImageSharp {
              gatsbyImageData(
                width: 1100
                quality: 90
                placeholder: BLURRED
                formats: [AUTO, WEBP]
                transformOptions: { fit: COVER, cropFocus: CENTER }
              )
            }
          }
        }
      }
    }
  }
`;

export const CoreImageBlockPreview = `
  ... on CoreImageBlock {
    name
    attributes {
      __typename
      ... on CoreImageBlockAttributes {
        align
        alt
        caption
        className
        height
        href
        id
        linkClass
        linkDestination
        linkTarget
        rel
        sizeSlug
        title
        url
        width
      }
    }
  }`;
const getDimensions = (url) => {
  // parse url string, look for width and height e.g 1000x500
  const dimensions = url.match(/\d{2,4}x\d{2,4}/g);
  // if no dimensions found, return null
  if (!dimensions) return null;
  // split dimensions into array
  const dimensionsArray = dimensions[0].split("x");
  // return object with width and height
  return {
    width: dimensionsArray[0],
    height: dimensionsArray[1],
  };
};
